<template>
  <productIssueProgress title="产品问题信息"/>
</template>

<script>
import productIssueProgress from './productIssueProgress';

export default {
  name: 'homeProductIssueInfo',
  components: {
    productIssueProgress
  }
};
</script>

<style scoped lang="scss">
</style>
